module.exports = __webpack_public_path__ + "img/0Q3A6453_L_Foamcore_MockedUp.833bde40.jpg";